<!--
 * @Author: czj
 * @Date: 2025-04-10 18:51:56
 * @Description: 
 * @FilePath: \test-demo2\src\components\ContentCom\comps\ResultsDirectory.vue
-->
<template>
  <div v-if="props.filtered_data && props.filtered_data.length>0">
    <p class="section_text">结果目录:</p>
    <div class="results_directorys">
      <div class="line_text_box" v-for="(item, index) in props.filtered_data" :key="index">
        <div class="line_text" @click="openFiles(item)">{{item.path}}</div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, defineEmits } from 'vue';
  import { useStore } from '@/Store/index.js';
  const store = useStore();
  const emit = defineEmits([])
  const props = defineProps(['filtered_data']);

  const openFiles = function (item) {
    if (store.app_id && item.path) {
      window.open(`${item.path}/`)
    }
  };
</script>
<style scoped>
  .section_text {
    font-size: .87rem;
    text-indent: 2em;
    margin-bottom: 10px;
    line-height: 1.7;
  }

  .results_directorys {
    font-size: .8rem;
  }

  .results_directorys .line_text {
    margin-bottom: 10px;
    cursor: pointer;
    padding-bottom: 2px;
    display: inline-block;
    margin-left: 3em;
  }

  .results_directorys .line_text:hover {
    border-bottom: 1px solid var(--theme-color);
  }
</style>